export default __webpack_public_path__ + "static/media/home-portfolio-shep.5964adac.png";